import {Box, Typography} from '@mui/material';

const OverviewTopic = () => {
  return (
    <Typography component='div'>
      <p>
        These help topics describe how to use the Herd Portal and provide answers to frequently asked questions.
      </p>

      <p>
        For additional support, contact Chip directly at home, at any hour of the night, at chip@example.com or even
        better, 1-800-ASK-CHIP.
      </p>

      <h3>Basics</h3>

      <p>
        Some description of the features and pages of the Herd Portal could go here...
      </p>
    </Typography>
  );
};

export default OverviewTopic;